import { GET_BAFL_KYC_REPORT } from "../../../Types";

const BaflKycReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_BAFL_KYC_REPORT:
      return action.payload;

    default:
      return state;
  }
};
export default BaflKycReportReducer;
